import { Shader3D } from "../../../../RenderEngine/RenderShader/Shader3D";
export class Command {
    static __init__() {
        Command._screenShader = Shader3D.find("BlitScreen");
        Command.SCREENTEXTURE_ID = Shader3D.propertyNameToID(Command.SCREENTEXTURE_NAME);
        Command.SCREENTEXTUREOFFSETSCALE_ID = Shader3D.propertyNameToID(Command.SCREENTEXTUREOFFSETSCALE_NAME);
        Command.MAINTEXTURE_TEXELSIZE_ID = Shader3D.propertyNameToID(Command.MAINTEXTURE_TEXELSIZE_NAME);
    }
    constructor() {
        this._commandBuffer = null;
    }
    recover() {
        this._commandBuffer = null;
    }
    destroy() {
        this._commandBuffer = null;
        this._context = null;
    }
}
Command.SCREENTEXTURE_NAME = "u_MainTex";
Command.SCREENTEXTUREOFFSETSCALE_NAME = "u_OffsetScale";
Command.MAINTEXTURE_TEXELSIZE_NAME = "u_MainTex_TexelSize";
